import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ExternalLink } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WebsitesSection = () => {
  const [websites, setWebsites] = useState([]);

  useEffect(() => {
    const fetchWebsites = async () => {
      try {
        const res = await axios.get(`${API}/websites`);
        setWebsites(res.data);
      } catch (err) {
        console.error('Failed to fetch websites:', err);
      }
    };
    fetchWebsites();
  }, []);

  if (websites.length === 0) return null;

  return (
    <section className="section-padding" style={{
      background: 'linear-gradient(180deg, #0f0a1e 0%, #1a0e2e 100%)',
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Our <span style={{ color: '#00d4ff' }}>Websites</span>
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '15px',
          color: '#b0adc0',
          marginBottom: '12px',
        }}>
          Explore our network of platforms for spiritual growth and human connection.
        </p>
        <div className="section-divider" style={{ marginBottom: '50px' }} />

        <div className="grid-websites">
          {websites.map((site) => (
            <a
              key={site.website_id}
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              className="glass-card"
              style={{
                padding: '32px',
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: 700,
                  color: '#ffffff',
                }}>
                  {site.title}
                </h3>
                <ExternalLink size={18} color="#8885a0" />
              </div>
              <p style={{ fontSize: '14px', color: '#b0adc0', lineHeight: 1.6 }}>
                {site.description}
              </p>
              <span style={{
                fontSize: '13px',
                color: '#00d4ff',
                fontWeight: 500,
              }}>
                {site.domain}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebsitesSection;
